import "@/App.css";
import { Toaster } from "sonner";
import { SmoothScroll } from "@/components/site/SmoothScroll";
import { Nav } from "@/components/site/Nav";
import { HeroSuite } from "@/components/site/HeroSuite";
import { Marquee } from "@/components/site/Marquee";
import { Services } from "@/components/site/Services";
import { Suite } from "@/components/site/Suite";
import { Lifecycle } from "@/components/site/Lifecycle";
import { Method } from "@/components/site/Method";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";
import { WhatsAppFab } from "@/components/site/WhatsAppFab";

function App() {
  return (
    <div className="App">
      <SmoothScroll />
      <Nav />
      <main>
        <HeroSuite />
        <Marquee />
        <Suite />
        <Lifecycle />
        <Services />
        <Method />
        <Contact />
      </main>
      <Footer />
      <WhatsAppFab />
      <Toaster theme="dark" position="top-center" richColors />
    </div>
  );
}

export default App;
